/**
 * Lotto Loco keyframes injected into <head> exactly once.
 *
 * Keyframes scoped through MUI's JSS get unique generated names that aren't
 * referenceable from inline `style={{ animationDuration: ... }}` props (each
 * reel row needs its own duration). A global stylesheet keeps the keyframe
 * names stable so callers can compose them dynamically.
 */
export const STYLE_TAG_ID = "lotto-loco-keyframes";

export const KEYFRAMES_CSS = `
@keyframes lottoLocoSpin { 0% { transform: translateY(0); } 100% { transform: translateY(-50%); } }
@keyframes lottoLocoBounce { 0% { transform: scale(0.6); opacity: 0; } 60% { transform: scale(1.08); opacity: 1; } 100% { transform: scale(1); opacity: 1; } }
@keyframes lottoLocoShakeFast { 0%, 100% { transform: rotate(0); } 25% { transform: rotate(-3deg); } 75% { transform: rotate(3deg); } }
@keyframes lottoLocoConfetti { 0% { transform: translateY(0) rotate(0); opacity: 1; } 100% { transform: translateY(360px) rotate(540deg); opacity: 0; } }
@keyframes lottoLocoFadeIn { 0% { opacity: 0; transform: translateY(-4px); } 100% { opacity: 1; transform: translateY(0); } }
`;

export const ensureKeyframes = () => {
  if (typeof document === "undefined") return;
  if (document.getElementById(STYLE_TAG_ID)) return;
  const tag = document.createElement("style");
  tag.id = STYLE_TAG_ID;
  tag.textContent = KEYFRAMES_CSS;
  document.head.appendChild(tag);
};
